export const getFormFieldValue = (field, element) =>
  field?.component === "boolean" ? Boolean(element?.checked) : element?.value;

const parseLocationValue = (value) => {
  if (!value) return null;

  if (typeof value === "object") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const isValidLatitude = (value) => Number.isFinite(value) && value >= -90 && value <= 90;
const isValidLongitude = (value) => Number.isFinite(value) && value >= -180 && value <= 180;

export const getLocationCoordinates = (value) => {
  const location = parseLocationValue(value);
  const source = location?.point || location?.center;
  const latitude = Number(source?.lat);
  const longitude = Number(source?.lng);

  if (!isValidLatitude(latitude) || !isValidLongitude(longitude)) {
    return null;
  }

  return {
    vc_lat: String(latitude),
    vc_lon: String(longitude),
  };
};

const getMessagesFromErrors = (errors) => {
  if (Array.isArray(errors)) {
    return errors
      .map((error) => (typeof error === "string" ? error : error?.message))
      .filter(Boolean);
  }

  if (typeof errors === "string" && errors.trim()) {
    return [errors];
  }

  if (errors && typeof errors === "object" && typeof errors.message === "string") {
    return errors.message.trim() ? [errors.message] : [];
  }

  return [];
};

export const getSaveErrorMessage = (error) => {
  const messages = getMessagesFromErrors(error?.errors);

  if (messages.length > 0) {
    return messages.join("\n");
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return "No se ha podido guardar el registro";
};
